//
// Crosstab.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../BaseUIModel";
import "../data/dataset/DataSet";
import "../data/tree/DataTreeNode";
import "../data/hierarchy/Hierarchy";
import "../../styles/Style";
import "../../styles/StyleChain";
import "../data/hierarchy/HierarchyDataSet";
import "../data/sorting/DataTreeSortContext";
import "../data/hierarchy/Level";
import "../../rules/expressions/Expression";
import "../datagrid/TableSelectionType";
import "../../datagrid/GridColumnInfoManager";
import "../../BaseView";
import "../../rules/interfaces/Rule";
import "../datagrid/DataGridColumnInfo";
import "./CrosstabLevelInfo";

var Crosstab = createModule("commons::Crosstab", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    {
        ROW_HEADER_UPDATED: 20018,
        COLUMN_HEADER_UPDATED: 20019,
        DATASET_UPDATED: 20020,
        SELECTED_CHANGED: 20017,
    },
    {
        suppressedTotalMeasureNames: [7],
        showDrillAsHyperLinkText: 2,
        scrollbarStyle: 1,
        totalStyle: 1,
        columnAutoFill: 2,
        showAxisHeaders: 2,
        columnIndentedViewMode: 2,
        columnHierarchy: 1,
        selectionStyle: 1,
        showRowTotal: 2,
        suppressedSubtotalMeasureNames: [7],
        sourceDataSet: 1,
        rowHierarchy: 1,
        rowHeaderStyle: 1,
        rowNumberHeaderLabel: 7,
        measureColumnNames: [7],
        columnDataTreeNode: 1,
        headerStyleTransposed: 2,
        displayInteractionButtons: 2,
        dataTreeSortContext: 1,
        allowColumnResizing: 2,
        showColumnSubTotal: 2,
        tableStyle: 1,
        rowHeaderLabelStyle: 1,
        showSummaryOnTop: 2,
        levelViewMode: 2,
        sortContext: 1,
        subtotalStyleClass: 2,
        columnAxisLevels: [1],
        style: 1,
        brushStyle: 1,
        selectionExpression: 1,
        columnHeaderStyle: 1,
        measureWidth: 4,
        selectionMode: 4,
        hierarchyDataSet: 1,
        columnInfoManager: 1,
        rowTotalIndices: [4],
        rowHierarchyNames: [7],
        showColumnTotal: 2,
        rowSubtotalIndices: [4],
        rowAxisLevels: [1],
        rowDataTreeNode: 1,
        rowIndentedViewMode: 2,
        dataSet: 1,
        columnHeaderLabelStyle: 1,
        showRowSubTotal: 2,
        showRowNumbers: 2,
        subtotalStyle: 1,
        omittedSubtotalColumnLevelNames: [7],
        showMissingLabelAsBlank: 2,
        indentedViewMode: 2,
        columnActionEnabled: 2,
        excludedColumnNames: [7],
        rowActionEnabled: 2,
        showRowNumberByHeader: 2,
        columnHierarchyNames: [7],
        transpose: 2,
        numberOfMeasures: 4,
        showEmptyRowsAndColumns: 2,
        measureHeaderStyle: 1,
    },
    ,
    ,
    {
        createRenderer: [1],
        _setDisplayRule_nob: [0,4,1,2],
        setColumnLevelInfo: [0,4,1],
        setRowLevelInfo: [0,4,1],
        getColumnInfo: [1,4],
        setColumnInfo: [0,4,1],
        getColumnLevelInfo: [1,4],
        _setDisplayRule_no: [0,4,1],
        updateRowHeader: [0],
        getDisplayRule: [1,4],
        updateColumnHeader: [0],
        updateDataSet: [0],
        getRowLevelInfo: [1,4],
    },
    {
        _create: [4],
    },
    ["setDisplayRule"],
]);
export default Crosstab;
